import { trackOperation } from 'events/ops/opsEvent';

/**
 * Wraps a heartProduct dispatch to emit SaveToFavorites ops events.
 *
 * heartProduct's internal .catch swallows rejections and resolves with
 * dispatch(toggleHeartingLoginModal(...)) — a plain action object — after
 * cleanup. On success (200), the promise resolves with undefined.
 * We use the resolved value to distinguish success from caught failure.
 *
 * When the user is unrecognized, dispatch(heartProduct(...)) returns a
 * plain action (login modal) rather than a Promise — we skip tracking.
 */
export function trackableHeartProduct(dispatch: Function, heartProductAction: Function, args: object, callback?: Function) {
  const result = dispatch(heartProductAction(args, callback));

  // heartProduct returns a Promise only for recognized users.
  // Unrecognized users get a plain Redux action (login modal) — skip tracking.
  if (result && typeof result.then === 'function') {
    result.then((resolved: unknown) => {
      // heartProduct's .catch resolves with a dispatched action (truthy object).
      // The success path resolves with undefined (no explicit return).
      if (resolved !== undefined) {
        trackOperation('SaveToFavorites', 'failure');
      } else {
        trackOperation('SaveToFavorites', 'success');
      }
    });
  }
}
